import styled from 'styled-components';

import { IconButton } from '@xemplo/icon-button';

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
`;
